import type { CSSProperties } from "react";
import { cx } from "../lib/cx";

export type SkeletonShape = "line" | "title" | "box" | "custom";

/** ใช้แทน spinner ตอนโหลดหน้า แสงวิ่งหยุดเมื่อ prefers-reduced-motion */
export function Skeleton({ shape = "line", style, className }: { shape?: SkeletonShape; style?: CSSProperties; className?: string }) {
  return <div className={cx("skel", shape === "line" && "skel-line", shape === "title" && "skel-title", shape === "box" && "skel-box", className)} style={style} aria-hidden="true" />;
}

/** fallback ตอนโหลด chunk ของหน้า (route-level code splitting) */
export function PageLoading() {
  return (
    <div className="page" role="status" aria-busy="true">
      <div className="container stack">
        <Skeleton shape="title" />
        <Skeleton shape="box" />
      </div>
    </div>
  );
}
